import {
  IOrderHistoryCreateRequest,
  ISingleOrderHistoryResponse,
} from "types/OrderHistory";

import { api, publicApi } from ".";

const orderHistoryBody = (orderHistory: IOrderHistoryCreateRequest) => ({
  type: orderHistory.type,
  orderId: orderHistory.orderId,
  description: orderHistory.description,
  userId: orderHistory.userId || null,
  note: orderHistory.note || null,
  amountInCents: orderHistory.amountInCents || null,
  toProviderId: orderHistory.toProviderId || null,
  externalPaymentMethod: orderHistory.externalPaymentMethod || null,
});

/**
 * Patient-side history writes (OrderOverview, OrderUpdate, DirectPay). These carry the
 * order-bound patient token; the API checks the body's orderId against it (CLE-2181).
 */
const publicOrderHistoryQueries = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    createOrderHistory: builder.mutation<
      ISingleOrderHistoryResponse,
      IOrderHistoryCreateRequest
    >({
      query: (orderHistory) => ({
        body: orderHistoryBody(orderHistory),
        method: "POST",
        url: "/order_histories",
      }),
    }),
  }),
});

/**
 * Staff-side history writes (OrderView). Authenticates as staff via Auth0 rather than borrowing
 * a patient token: PaymentDetailsSection only mounts for PAID/PARTIALLY_PAID/REFUNDED orders, so
 * on an unpaid order there is no patient token in redux to borrow.
 */
const staffOrderHistoryQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    createOrderHistoryAsStaff: builder.mutation<
      ISingleOrderHistoryResponse,
      IOrderHistoryCreateRequest
    >({
      query: (orderHistory) => ({
        body: orderHistoryBody(orderHistory),
        method: "POST",
        url: "/order_histories",
      }),
    }),
  }),
});

export const { useCreateOrderHistoryMutation } = publicOrderHistoryQueries;
export const { useCreateOrderHistoryAsStaffMutation } =
  staffOrderHistoryQueries;
